import { Card, Stack, Typography } from "@mui/material";
import type React from "react";

interface CardWithTitleProps {
  title: string;
  subtitle?: React.ReactNode;
  body: React.ReactNode;
}

export const CardWithTitle = ({
  title,
  subtitle,
  body,
}: CardWithTitleProps) => {
  return (
    <Card sx={{ padding: 4 }}>
      <Stack spacing={2}>
        <Typography variant="h6">{title}</Typography>
        {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
        {body}
      </Stack>
    </Card>
  );
};
